export default __webpack_public_path__ + "0750b6874d5ee1cdc236664ac9c13cca.png";